import {
  FETCH_ALERTS,
  FETCH_ALERTS_SUCCESS,
  FETCH_ALERTS_FAIL,
  CHANGE_ALERT_LIST_PAGE,
  UPDATE_ALERT_LIST_FILTERS,
  SELECT_ALERTS_ID,
  SELECT_ALERTS,
  RELOAD_ALERTS,
  FETCH_TYPOLOGIES_SUCCESS,
  CHANGE_ALERT_LIST_PAGE_SIZE,
  FETCH_SOURCES_SUCCESS
} from '../../actions/cm/alertList';
import {
  CHANGE_ALERT_STATUS,
  CHANGE_ALERT_ASSIGN_TO_USER
} from '../../actions/cm/alertDetails';
import { ALERT_ACTION_INFO_MODAL_CLOSE } from '../../actions/cm/alertAction';
import {
  DEFAULT_DATE_RANGE_DAYS,
  DEFAULT_PAGE_SIZE
} from '../../../pages/constants/cmConstants';
import { CREATE_CASE_FROM_ALERT_SUCCESS } from '../../actions/cm/convertAlertsToCase';
import { MERGE_ALERTS_TO_CASE_SUCCESS } from '../../actions/cm/mergeAlertsToCase';
import { fromDaysToRangeBack } from '../../../pages/cm/utils/common';

const { from, to } = fromDaysToRangeBack(DEFAULT_DATE_RANGE_DAYS);

export const initialState = {
  isLoading: false,
  list: [],
  hasLoaded: false,
  total: 0,
  hasError: false,
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  filters: {
    status: null,
    alertLevel: null,
    from,
    to,
    searchField: '',
    searchText: '',
    typologyIds: [],
    sourceIds: [],
    watchlistCategory: undefined,
    watchlistSubCategory: undefined,
    watchlistKeyword: undefined,
    externalSource: undefined,
    watchlistSource: undefined
  },
  selectedIds: [],
  selectedAlerts: [],
  typologies: [],
  sources: []
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_ALERTS:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_ALERTS_SUCCESS:
      // FIN-11336: If the current page overshoots the new total (e.g. after
      // converting the last page's alerts to a case), clamp to the last valid
      // page; the useEffect refetches automatically because hasLoaded is false.
      if (
        payload.alerts.length === 0 &&
        state.currentPage > 1 &&
        payload.total > 0
      ) {
        return {
          ...state,
          list: [],
          total: payload.total,
          currentPage: Math.ceil(payload.total / state.pageSize),
          hasLoaded: false,
          isLoading: true
        };
      }
      return {
        ...state,
        list: payload.alerts,
        total: payload.total,
        isLoading: false,
        hasLoaded: true
      };
    case FETCH_ALERTS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    case CHANGE_ALERT_LIST_PAGE:
      // FIN-10962: Preserve selection across page changes so Convert / Merge /
      // Assign continue to work on cross-page selections. Bulk Update is
      // disabled at the UI level when selection spans pages (see AlertList.js).
      return {
        ...state,
        currentPage: payload,
        hasLoaded: false
      };
    case UPDATE_ALERT_LIST_FILTERS:
      return {
        ...state,
        filters: payload,
        hasLoaded: false,
        currentPage: 1,
        selectedIds: [],
        selectedAlerts: []
      };
    case SELECT_ALERTS_ID:
      return {
        ...state,
        selectedIds: payload
      };
    case SELECT_ALERTS:
      return {
        ...state,
        selectedAlerts: payload
      };
    case RELOAD_ALERTS:
    case CREATE_CASE_FROM_ALERT_SUCCESS:
    case MERGE_ALERTS_TO_CASE_SUCCESS:
    case ALERT_ACTION_INFO_MODAL_CLOSE:
      return {
        ...state,
        hasLoaded: false,
        selectedIds: [],
        selectedAlerts: []
      };
    case CHANGE_ALERT_STATUS:
    case CHANGE_ALERT_ASSIGN_TO_USER:
      return {
        ...state,
        hasLoaded: false
      };
    case FETCH_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        typologies: payload
      };
    case FETCH_SOURCES_SUCCESS:
      return {
        ...state,
        sources: payload
      };
    case CHANGE_ALERT_LIST_PAGE_SIZE:
      return {
        ...state,
        pageSize: payload,
        selectedIds: [],
        hasLoaded: false
      };

    default:
      return state;
  }
}
